import { render, staticRenderFns } from "./LeavePageStatistics.vue?vue&type=template&id=5821e730&scoped=true&"
import script from "./LeavePageStatistics.vue?vue&type=script&lang=js&"
export * from "./LeavePageStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821e730",
  null
  
)

export default component.exports